import React, { useLayoutEffect, useRef, useState } from 'react';
import { Modal } from 'antd';
import { DownOutlined, UpOutlined } from '@ant-design/icons';
import parse from 'html-react-parser';
import benefits from './benefits.json';
import terms from './terms.json';
import './style.scss';

function BenefitValue({ value, tier }) {
  if (typeof value === 'boolean') {
    return (
      <span className={value ? 'ihg-benefits__included' : 'ihg-benefits__excluded'}>
        <span className="ihg-benefits__sr-only">
          {tier}{value ? '享有此礼遇' : '不含此礼遇'}
        </span>
      </span>
    );
  }
  return value;
}

export default function IHGBenefits() {
  const pageRef = useRef(null);
  const [activeTier, setActiveTier] = useState('club');
  const [termsOpen, setTermsOpen] = useState(false);

  useLayoutEffect(() => {
    // Other routes set a fixed rem width on the shared H5 container.
    const container = pageRef.current.closest('.container');
    if (!container) return;
    container.classList.add('ihg-benefits-container');
    return () => container.classList.remove('ihg-benefits-container');
  }, []);

  return (
    <main ref={pageRef} className="ihg-benefits" lang="zh-CN">
      <h1 className="hotel-member-title">
        <img className="hotel-member-logo ihg-logo" src="https://staticfile.badazhou.com/20260921/6ff9b9be3e623879b9e242a5db0e7037.png" alt="" />
        <span>IHG优悦会-会员礼遇</span>
      </h1>

      <div className="ihg-benefits__overview">
        <div className="content-fragment-table" role="region" aria-label="会员等级礼遇对照表" tabIndex={0}>
          <table className="cmp-content-fragment-table" aria-describedby="ihg-benefits-caption">
            <caption id="ihg-benefits-caption">{benefits.caption}<span className="fs-12 c-99">（向左滑动查看更多会员等级）</span></caption>
            <thead>
              <tr>
                <th scope="col">{benefits.columnHeading}</th>
                {benefits.tiers.map((tier) => <th scope="col" key={tier.id}>{tier.title}</th>)}
              </tr>
            </thead>
            {benefits.sections.map((section, sectionIndex) => (
              <tbody key={sectionIndex}>
                {Boolean(section.title) && (
                  <tr className="ihg-benefits__section-heading">
                    <th scope="rowgroup" colSpan={6}><span>{section.title}</span></th>
                  </tr>
                )}
                {section.rows.map((row) => (
                  <tr key={row.label}>
                    <th scope="row">
                      {row.isNew ? <><b className="ihg-benefits__new">全新</b>{row.label.slice(2)}</> : row.label}
                    </th>
                    {row.values.map((value, index) => (
                      <td key={benefits.tiers[index].id} className={`ihg-benefits__${benefits.tiers[index].id}`}>
                        <BenefitValue value={value} tier={benefits.tiers[index].title} />
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            ))}
          </table>
        </div>
        <div className="ihg-benefits__footnotes">
          <p>
            请参阅 <button type="button" className="ihg-benefits__text-button" onClick={() => setTermsOpen(true)}>
              IHG 优悦会会员条款与附则
            </button>，了解全部礼遇详情。
          </p>
          <p className="ihg-benefits__disclosure">{benefits.footnote}</p>
          
        </div>
      </div>

      <section className="ihg-benefits__details" aria-labelledby="ihg-benefits-details-title">
        <h2 id="ihg-benefits-details-title">浏览各项礼遇</h2>
        <div className="ihg-benefits__tiers">
          {benefits.tiers.map((tier) => {
            const expanded = activeTier === tier.id;
            return (
              <section className="ihg-benefits__tier" key={tier.id}>
                <h3>
                  <button
                    type="button"
                    className="ihg-benefits__tier-toggle"
                    id={`ihg-tier-${tier.id}`}
                    aria-expanded={expanded}
                    aria-controls={`ihg-panel-${tier.id}`}
                    onClick={() => setActiveTier(expanded ? null : tier.id)}
                  >
                    {tier.title}
                    {expanded ? <UpOutlined aria-hidden="true" /> : <DownOutlined aria-hidden="true" />}
                  </button>
                </h3>
                <div
                  className="ihg-benefits__tier-content"
                  id={`ihg-panel-${tier.id}`}
                  role="region"
                  aria-labelledby={`ihg-tier-${tier.id}`}
                  hidden={!expanded}
                >
                  <h4>{tier.heading}</h4>
                  <p className="ihg-benefits__tier-intro">{tier.intro}</p>
                  <dl>
                    {tier.benefits.map((benefit) => (
                      <div className="ihg-benefits__description" key={benefit.title}>
                        <dt>{benefit.title}</dt>
                        <dd>{benefit.description}</dd>
                      </div>
                    ))}
                  </dl>
                </div>
              </section>
            );
          })}
        </div>
      </section>

      <Modal
        title="IHG 优悦会会员条款与附则"
        open={termsOpen}
        onCancel={() => setTermsOpen(false)}
        footer={null}
        centered
        destroyOnClose
        width={720}
        className="ihg-benefits-dialog"
      >
        <div className="ihg-benefits-dialog__content" lang="zh-CN">
          {terms.sections.map((section) => (
            <section key={section.title}>
              <h2>{section.title}</h2>
              {section.blocks.map((block, index) => (
                <div className="ihg-benefits-dialog__block" key={index}>{parse(block, { trim: true })}</div>
              ))}
            </section>
          ))}
        </div>
      </Modal>
    </main>
  );
}
